import React from 'react'
import { ButtonPrimary } from '../Button'
import { CHAINS, CURRENT_CHAIN } from '@hyperswap/addresses'
import { SUPPORTED_WALLETS } from '../../constants'

const SwitchNetworkButton: React.FC = () => {
  const switchNetwork = async (chainId: keyof typeof CHAINS) => {
    const network = CHAINS[chainId]

    if (!network) return
    let provider: any
    const lastConnector = localStorage.getItem('connector')
    if (lastConnector && SUPPORTED_WALLETS[lastConnector]['connector']) {
      provider = await SUPPORTED_WALLETS[lastConnector].connector?.getProvider()

      const handleChainChanged = (_chainId: string) => {
        // Reload only if the chain id is the right one
        if (_chainId.toLowerCase() === network.chainId.toLowerCase()) {
          provider.removeListener('chainChanged', handleChainChanged)
          window.location.reload()
        }
      }
      if (provider.on) {
        provider.on('chainChanged', handleChainChanged)
      }
    }
    if (provider) {
      try {
        await provider?.request({
          method: 'wallet_requestPermissions',
          params: [{ eth_accounts: {} }],
        })
        // This error code indicates that the chain has not been added to MetaMask
        // @ts-ignore
        await provider?.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: network.chainId }],
        })
      } catch (switchError) {
        // This error code indicates that the chain has not been added to MetaMask
        // @ts-ignore
        if (switchError?.code === 4902 || switchError?.code === -32603) {
          try {
            await provider?.request({
              method: 'wallet_addEthereumChain',
              params: [network],
            })
            await provider?.request({
              method: 'wallet_switchEthereumChain',
              params: [{ chainId: network.chainId }],
            })
          } catch (addError) {
            console.error('Failed to add the network:', addError)
          }
        } else {
          console.error('Failed to switch the network:', switchError)
        }
      }
    } else {
      console.error('No supported wallet found!')
    }
  }

  return (
    <ButtonPrimary marginTop={3} onClick={() => switchNetwork(CURRENT_CHAIN)}>
      Switch to HyperEVM
    </ButtonPrimary>
  )
}

export default SwitchNetworkButton
